export const SET_ESTABLISHMENT_ID = 'BUSINESS_INFO/SET_ESTABLISHMENT_ID';
export const SET_ESTABLISHMENT_UUID = 'BUSINESS_INFO/SET_ESTABLISHMENT_UUID';
export const SET_PREVIOUS_ESTABLISHMENT_ID = 'BUSINESS_INFO/SET_PREVIOUS_ESTABLISHMENT_ID';
export const SET_BUSINESS_INFO = 'BUSINESS_INFO/SET_BUSINESS_INFO';
export const SET_ESTABLISHMENT_TYPES = 'BUSINESS_INFO/SET_ESTABLISHMENT_TYPES';
export const CLEAR_BUSINESS_INFO = 'BUSINESS_INFO/CLEAR_BUSINESS_INFO';
export const CLEAR_ADDRESS = 'BUSINESS_INFO/CLEAR_ADDRESS';
export const HANDLE_POSTAL_CODE = 'BUSINESS_INFO/HANDLE_POSTAL_CODE';
export const HANDLE_LOADING = 'BUSINESS_INFO/HANDLE_LOADING';
export const HANDLE_EDITING = 'BUSINESS_INFO/HANDLE_EDITING';
export const SET_ESTABLISHMENTS = 'BUSINESS_INFO/SET_ESTABLISHMENTS';
export const SET_ESTABLISHMENT_ERRORS = 'BUSINESS_INFO/SET_ESTABLISHMENT_ERRORS';
export const CLEAR_ESTABLISHMENT_ERRORS = 'BUSINESS_INFO/CLEAR_ESTABLISHMENT_ERRORS';
export const SET_SUPERLOGICA_LIST = 'BUSINESS_INFO/SET_SUPERLOGICA_LIST';
export const SET_JUMP_CAR_STORE_DOWNLOAD = 'BUSINESS_INFO/SET_JUMP_CAR_STORE_DOWNLOAD';
export const SET_IS_JUMP_CAR_STORE_DOWNLOAD_LOADING = 'BUSINESS_INFO/SET_IS_JUMP_CAR_STORE_DOWNLOAD_LOADING';
export const SET_IS_JUMP_CAR_STORE_DOWNLOAD_AVAILABLE = 'BUSINESS_INFO/SET_IS_JUMP_CAR_STORE_DOWNLOAD_AVAILABLE';